import { useState } from 'react';

import CheckboxInput from 'src/components/ui/CheckboxInput';

export default function MuteToggle() {
    const [muted, setMuted] = useState(false);

    const setMute = (nextMuted) => {
        const iframe = document.querySelector('iframe');

        iframe?.contentWindow?.postMessage({ type: 'pokiSetMute', muted: nextMuted }, '*');
    };

    const handleMuteChange = (nextMuted) => {
        setMuted(nextMuted);
        setMute(nextMuted);
    };

    return (
        <CheckboxInput
            id="mute-game"
            label="Mute"
            checked={muted}
            onChange={handleMuteChange}
        />
    );
}
